import { ConversationModes } from "./agent_conversation_modes.enum";

export class MessageSource {
    url?: string;
    name: string = "";
    source: ConversationModes = ConversationModes.FintraxData;

    deserialize(data: any) {
        this.url = data.url ?? undefined;
        this.name = data.name ?? '';
        this.source = data.source ?? ConversationModes.FintraxData;
        return this;
    }
}
